import { render } from "./WbList.vue?vue&type=template&id=524a8b64&scoped=true&ts=true"
import script from "./wbListHelper.ts?vue&type=script&lang=ts"
export * from "./wbListHelper.ts?vue&type=script&lang=ts"

import "./WbList.vue?vue&type=style&index=0&id=524a8b64&scoped=true&lang=css"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524a8b64"]])

export default __exports__